import { IApplicationState } from '../../types/redux';

export function selectJsonQuery(state: IApplicationState) {
  return state.filters.jsonQuery;
}
